import { useStyles } from '@webapps/styles';
import Accounting from './components/Accounting';
import { Grid } from '@material-ui/core';
import Actions from './components/Actions';
import Opco from './components/Opco';
import School from './components/School';
import Training from './components/Training';
import Convention from './components/Convention';
import LastBillings from './components/LastBillings';
import LastRecords from './components/LastRecords';
import LastTrainings from './components/LastTrainings';
import { getDashboardStats } from '@webapps/business';
import { useAuth, useQuery } from '@webapps/reactjs-tech-components';

const DashboardCFA = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const { data: dashboardStats = [] } = useQuery(getDashboardStats, {
    key: ['opcoRecords'],
    variables: {
      id: idUser,
    },
    keepPreviousData: true
  });

  return (
    <div className={cx(global.container, classes.container)}>
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={6} md={3}>
          <Opco stat={dashboardStats?.opcos} />
        </Grid>
        <Grid item xs={6} md={3}>
          <School stat={dashboardStats?.schools} />
        </Grid>
        <Grid item xs={6} md={3}>
          <Training stat={dashboardStats?.trainings} />
        </Grid>
        <Grid item xs={6} md={3}>
          <Convention stat={dashboardStats?.models} />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Accounting />
        </Grid>
        <Grid item xs={12} md={6}>
          <Actions />
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.lastSection}>
        <Grid item xs={12} md={4} className={classes.gridItem}>
          <LastBillings />
        </Grid>
        <Grid item xs={12} md={4} className={classes.gridItem}>
          <LastRecords />
        </Grid>
        <Grid item xs={12} md={4} className={classes.gridItem}>
          <LastTrainings />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: "grid",
    gridTemplateRows: "auto auto 1fr",
    gap: "30px",
    height: 'calc(100vh - 65px)'
  },
  grid: {
    '& > div': {
      '@media (max-width: 1283px)': {
        flexBasis: '50% !important',
        maxWidth: '50% !important'
      }
    }
  },
  lastSection: {
    height: '100%',
    '@media (max-width: 1024px)': {
      height: 'auto',
      alignItems: 'stretch !important'
    },
    '& .MuiGrid-item': {
      height: '100%',
      display: 'flex !important',
      flexDirection: 'column',
      '& > *': {
        height: '100%'
      },
      '@media (max-width: 1024px)': {
        height: 'auto',
        '& > *': {
          height: 'auto'
        }
      }
    }
  },
  gridItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
});

export default DashboardCFA;